"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SigsSmartComposeSignalInfo {
    getSignalInformation(session) {
        const endTime = new Date();
        const sessionDuration = endTime.getTime() - session.date.getTime();
        const requestUrl = "/api/v2.0/me/signals";
        session.smartComposeInteractionList = this.dedup(session.smartComposeInteractionList);
        const postJsonRequest = {
            SignalType: "SmartComposeSummarized",
            StartTime: session.date,
            EndTime: endTime,
            Compliance: "CustomerContent",
            Application: {
                AadAppId: session.sessionInfo.application.aadAppId,
                AppName: session.sessionInfo.application.appName,
                AppVer: session.sessionInfo.application.appVer,
            },
            Actor: {
                ActorType: session.sessionInfo.actor.actorType,
                ActorId: session.sessionInfo.actor.actorId,
                ActorIdType: session.sessionInfo.actor.actorIdType,
                AadTenantId: session.sessionInfo.actor.aadTenantId // TenantId application for commercial users only
            },
            Device: {
                Os: session.sessionInfo.device.os,
                OsVer: session.sessionInfo.device.osVer,
                UserAgent: session.sessionInfo.device.userAgent,
            },
            CustomProperties: {
                dsatReported: 0,
                satReported: 0,
                SessionId: session.sessionId,
                SessionDuration: sessionDuration,
                SmartComposeType: session.sessionInfo.composeType,
                ModelVersion: session.modelVersion,
                SmartComposeInteractionList: session.smartComposeInteractionList
            }
        };
        return postJsonRequest;
    }
    // Dedup all the smart compose interactions based on trace id, because there can be multiple
    // interactions for same trace id reported by owa client, for ex. suggestion shown and suggestion
    // accepted are two separate events reported.
    dedup(smartComposeInteractionList) {
        let interactionMap = new Map();
        for (let currSmartComposeInteraction of smartComposeInteractionList) {
            if (interactionMap.has(currSmartComposeInteraction.suggestionTraceId)) {
                const interaction = interactionMap.get(currSmartComposeInteraction.suggestionTraceId);
                interaction.merge(currSmartComposeInteraction);
            }
            else {
                interactionMap.set(currSmartComposeInteraction.suggestionTraceId, currSmartComposeInteraction);
            }
        }
        let result = [];
        for (let interaction of interactionMap.values()) {
            result.push(interaction);
        }
        return result;
    }
}
exports.SigsSmartComposeSignalInfo = SigsSmartComposeSignalInfo;
